import { render, staticRenderFns } from "./HrmDocuments.vue?vue&type=template&id=577b54c0&"
import script from "./HrmDocuments.vue?vue&type=script&lang=js&"
export * from "./HrmDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports